// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"ContactInfo_Wrap__oZWYB","Item":"ContactInfo_Item__1-0xh","Title":"ContactInfo_Title__1XSAC","Info":"ContactInfo_Info__2mWhn"};